// extracted by mini-css-extract-plugin
export var alignBaseline = "_10-9";
export var alignCenter = "_10-5";
export var alignFlexEnd = "_10-7";
export var alignFlexStart = "_10-6";
export var alignSelfBaseline = "_10-e";
export var alignSelfCenter = "_10-a";
export var alignSelfFlexEnd = "_10-c";
export var alignSelfFlexStart = "_10-b";
export var alignSelfStretch = "_10-d";
export var alignStretch = "_10-8";
export var column = "_10-2";
export var columnReverse = "_10-4";
export var flex = "_10-0";
export var justifyCenter = "_10-f";
export var justifyFlexEnd = "_10-h";
export var justifyFlexStart = "_10-g";
export var justifySpaceAround = "_10-j";
export var justifySpaceBetween = "_10-i";
export var justifySpaceEvenly = "_10-k";
export var row = "_10-1";
export var rowReverse = "_10-3";
export var wrapNowrap = "_10-m";
export var wrapWrap = "_10-l";
export var wrapWrapReverse = "_10-n";